import { defineComponent as i, openBlock as l, createElementBlock as o, mergeProps as u, unref as e, renderSlot as g, createElementVNode as a, createCommentVNode as m } from "vue";
import { useScalarIcon as L } from "../hooks/useScalarIcon.js";
const V = { key: 0 }, f = { key: 1 }, H = { key: 2 }, w = { key: 3 }, k = { key: 4 }, M = { key: 5 }, Z = {
  name: "ScalarIconArrowElbowLeft"
}, _ = /* @__PURE__ */ i({
  ...Z,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: n } = L(s);
    return (p, t) => (l(), o("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(d)), [
      g(p.$slots, "default"),
      e(n) === "bold" ? (l(), o("g", V, t[0] || (t[0] = [
        a("path", { d: "M240.49,104.49l-96,96a12,12,0,0,1-17,0L36,109v43a12,12,0,0,1-24,0V80A12,12,0,0,1,24,68H96a12,12,0,0,1,0,24H53l83,83,87.51-87.52a12,12,0,0,1,17,17Z" }, null, -1)
      ]))) : e(n) === "duotone" ? (l(), o("g", f, t[1] || (t[1] = [
        a("path", {
          d: "M96,80,24,152V80Z",
          opacity: "0.2"
        }, null, -1),
        a("path", { d: "M237.66,90.34a8,8,0,0,0-11.32,0L136,180.69,71.31,116l30.35-30.34A8,8,0,0,0,96,72H24a8,8,0,0,0-8,8v72a8,8,0,0,0,13.66,5.66L60,127.31l70.34,70.35a8,8,0,0,0,11.32,0l96-96A8,8,0,0,0,237.66,90.34ZM32,132.69V88H76.69Z" }, null, -1)
      ]))) : e(n) === "fill" ? (l(), o("g", H, t[2] || (t[2] = [
        a("path", { d: "M237.66,101.66l-96,96a8,8,0,0,1-11.32,0L60,127.31,29.66,157.66A8,8,0,0,1,16,152V80a8,8,0,0,1,8-8H96a8,8,0,0,1,5.66,13.66L71.31,116,136,180.69l90.34-90.35a8,8,0,0,1,11.32,11.32Z" }, null, -1)
      ]))) : e(n) === "light" ? (l(), o("g", w, t[3] || (t[3] = [
        a("path", { d: "M236.24,100.24l-96,96a6,6,0,0,1-8.48,0L30,94.48V152a6,6,0,0,1-12,0V80a6,6,0,0,1,6-6H96a6,6,0,0,1,0,12H38.48L136,183.51l91.76-91.75a6,6,0,0,1,8.48,8.48Z" }, null, -1)
      ]))) : e(n) === "regular" ? (l(), o("g", k, t[4] || (t[4] = [
        a("path", { d: "M237.66,101.66l-96,96a8,8,0,0,1-11.32,0L32,99.31V152a8,8,0,0,1-16,0V80a8,8,0,0,1,8-8H96a8,8,0,0,1,0,16H43.31L136,180.69l90.34-90.35a8,8,0,0,1,11.32,11.32Z" }, null, -1)
      ]))) : e(n) === "thin" ? (l(), o("g", M, t[5] || (t[5] = [
        a("path", { d: "M234.83,98.83l-96,96a4,4,0,0,1-5.66,0L28,89.66V152a4,4,0,0,1-8,0V80a4,4,0,0,1,4-4H96a4,4,0,0,1,0,8H33.66L136,186.34l93.17-93.17a4,4,0,1,1,5.66,5.66Z" }, null, -1)
      ]))) : m("", !0)
    ], 16));
  }
});
export {
  _ as default
};
